import React, { useState, useEffect } from 'react';
import { ApplicantDropdown } from '../../../components/layout/form-fields/inputs/ApplicantDropdown';
import UserProfileAvatar from '../user-profile-avatar/UserProfileAvatar';

const ApplicantAssignmentInput = ({
	value = null,
	isMulti = false,
	placeholder = 'Select applicant',
	disabled = false,
	onChange,
	className = '',
	showAvatar = true,
	customStyles = {},
	customFieldActions = null,
	filterByJobId = null
}) => {
	const [selectedApplicant, setSelectedApplicant] = useState(null);
	const [assignedApplicants, setAssignedApplicants] = useState([]);
	const [primaryApplicantId, setPrimaryApplicantId] = useState(null);

	useEffect(() => {
		if (value) {
			if (isMulti && Array.isArray(value)) {
				setAssignedApplicants(value);

				const existingPrimary = value.find(
					applicant => applicant.isPrimary === true
				);

				if (existingPrimary) {
					setPrimaryApplicantId(existingPrimary.id);
				} else if (value.length > 0 && !primaryApplicantId) {
					setPrimaryApplicantId(value[0].id);
				}
			} else if (!isMulti && value) {
				setSelectedApplicant(value);
			}
		}
	}, [value, isMulti, primaryApplicantId]);

	const handleSave = value => {
		setSelectedApplicant(value);

		if (isMulti) {
			if (value) {
				const newApplicant = {
					...value,
					isPrimary: assignedApplicants.length === 0
				};
				const updatedApplicants = [...assignedApplicants, newApplicant];
				setAssignedApplicants(updatedApplicants);

				if (assignedApplicants.length === 0) {
					setPrimaryApplicantId(value.id);
				}

				if (onChange) {
					onChange(updatedApplicants);
				}
			}

			setSelectedApplicant(null);
		} else {
			if (onChange) {
				onChange(value);
			}
		}
	};

	const handleSetPrimary = applicantId => {
		setPrimaryApplicantId(applicantId);
		const updatedApplicants = assignedApplicants.map(applicant => ({
			...applicant,
			isPrimary: applicant.id === applicantId
		}));
		setAssignedApplicants(updatedApplicants);
		if (onChange) {
			onChange(updatedApplicants);
		}
	};

	const handleRemoveApplicant = applicantId => {
		const updatedApplicants = assignedApplicants.filter(
			applicant => applicant.id !== applicantId
		);
		setAssignedApplicants(updatedApplicants);

		if (primaryApplicantId === applicantId && updatedApplicants.length > 0) {
			setPrimaryApplicantId(updatedApplicants[0].id);
			updatedApplicants[0].isPrimary = true;
		} else if (updatedApplicants.length === 0) {
			setPrimaryApplicantId(null);
		}

		if (onChange) {
			onChange(updatedApplicants);
		}
	};

	const renderDisplayMode = () => {
		return (
			<div
				className="user-assignment-edit"
				style={{
					...(customStyles?.control || {})
				}}>
				<ApplicantDropdown
					value={selectedApplicant}
					placeholder={placeholder}
					styleVersion="ats"
					showAvatar={showAvatar}
					filterByJobId={filterByJobId}
					onValueChange={value => {
						handleSave(value);
					}}
				/>

				<div className="field-actions">{!disabled && customFieldActions}</div>
			</div>
		);
	};

	return (
		<div className={`user-assignment-input editing ${className}`}>
			{renderDisplayMode()}
			{assignedApplicants.length > 0 && (
				<div className="assigned-users">
					{assignedApplicants.map(applicant => (
						<div key={applicant.id} className="assigned-user-row">
							<div className="user-info">
								<button
									className="set-primary-btn"
									title="Primary"
									type="button"
									onClick={e => {
										e.preventDefault();
										handleSetPrimary(
											applicant.id === primaryApplicantId ? null : applicant.id
										);
									}}>
									<img
										src={
											applicant.id === primaryApplicantId
												? '/ats/icons/star-filled.svg'
												: '/ats/icons/star-empty.svg'
										}
										alt="Star"
									/>
								</button>
								<UserProfileAvatar
									imageUrl={applicant.imageUrl || applicant.candidate?.imageUrl}
									name={applicant.name}
									showName={true}
									size={21}
								/>
							</div>
							<div className="user-actions">
								<button
									title="Remove Applicant"
									type="button"
									onClick={() => handleRemoveApplicant(applicant.id)}>
									<img src="/ats/icons/trash-icon.svg" alt="Delete" />
								</button>
							</div>
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default ApplicantAssignmentInput;
